import { ValidationError } from '@superbet-group/web.lib.utilities';

import { logger } from '@app/logger';
import { UserService } from '@core/services/user/UserService';
import {
    sendVerifyIdentityEvent,
    AnalyticsKycEvent,
} from '@accountFederation/modules/idCardVerification/analytics/idVerificationAnalytics';
import { getIdVerificationStoreGetters } from '@accountFederation/modules/idCardVerification/analytics/idVerificationStoreGetters';
import { PhotoDeliveryMethods } from '@accountFederation/modules/idCardVerification/types';
import { errorGuard } from '@utils/ErrorGuard';

export default {
    methods: {
        onSubmit(this: any) {
            this.isLoading = true;
            this.error = '';

            const file = this.fields.file.value[0];
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async () => {
                await errorGuard(async () => {
                    await UserService.getInstance().uploadIdCard(reader.result as string, file.name);
                    sendVerifyIdentityEvent({
                        eventName: AnalyticsKycEvent.VerifyIdentityImageUpload,
                        type: this.documentTypeSelected,
                        method: PhotoDeliveryMethods.Upload,
                        idVerificationStoreGetters: getIdVerificationStoreGetters(),
                    });
                    this.$emit('success');
                }, {
                    onError: (e: any) => {
                        if (e instanceof ValidationError) {
                            this.asyncErrors = e.fieldErrors;
                        } else {
                            this.error = this.$t('Something went wrong. Please try again');
                            this.$emit('error', e);
                        }
                    },
                    showGlobalError: false,
                });
                this.isLoading = false;
            };
            reader.onerror = (e) => {
                this.isLoading = false;
                this.error = this.$t('Something went wrong. Please try again');
                logger.error((e as any));
            };
        },
    },
};
